import VueCookies from 'vue-cookies'

export const ACCESS_TOKEN = 'Authorization'
const ACCESS_PATH = '/'

export default {
  state: {
    token: VueCookies.get(ACCESS_TOKEN) || ''
  },
  mutations: {
    SET_TOKEN: (state, data) => {
      if (data) {
        state.token = data.token
        VueCookies.set(ACCESS_TOKEN, data.token, data.expire, ACCESS_PATH)
      } else {
        state.token = ''
        VueCookies.remove(ACCESS_TOKEN, ACCESS_PATH)
      }
    }
  },
  actions: {
    setToken({ commit }, data) {
      commit('SET_TOKEN', data)
    },
    clearToken({ commit }) {
      commit('SET_TOKEN')
    }
  },
  getters: {
    token: state => {
      return state.token
    }
  }
}
